import { NavigationItem } from '@app/components/navigation/NavigationItem';
import { Navigation } from '@typings';
import cx from 'classnames';

interface Props {
  item: Navigation.Item;
}

export const NavigationMenuItem = ({ item }: Props) => {
  return (
    <NavigationItem
      item={item}
      className={cx('transition-color inline-block h-10 px-1 py-2 text-neutral-20 heading-3', {
        'hover:text-neutral-40 focus-visible:rounded-large focus-visible:focus-outline': item.type !== 'folder',
      })}
      activeClassName="border-b border-current focus-visible:border-transparent"
    />
  );
};
